import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import styled from "styled-components";
import { boxShadow100 } from "../../../common/boxShadows";
import { useTranslation } from "../../../i18n/useTranslation";
import { scrollStylesCSS } from "../../newCommon/ControlsCommon";
import { renderNoOptionsDefault } from "../../tagInput/Default";
import { cssBody200Bold } from "../../typography/styles";
import { defaultDropdownHeight, renderOptionDefault, renderOptionsDefault, } from "../renders/default";
import { OptionLoading } from "./OptionLoading";
const _USelectDropdown = ({ renderOptions = renderOptionsDefault, renderOption = renderOptionDefault, renderNoOptions = renderNoOptionsDefault, renderHeader, ...props }) => {
    const { t } = useTranslation();
    const getWidth = useCallback(() => {
        const controlWidth = props.controlRef.current?.getBoundingClientRect().width || 0;
        return props.dropdownAutoWidth || !controlWidth ? "auto" : controlWidth + "px";
    }, [props.controlRef, props.dropdownAutoWidth]);
    const getMinWidth = useCallback(() => (props.controlRef.current?.getBoundingClientRect().width || 0) + "px", [props.controlRef]);
    return (_jsxs(Wrapper, { "$width": getWidth(), "$minWidth": getMinWidth(), children: [renderHeader?.(props), props.loading ? (_jsx(OptionLoading, {})) : (_jsxs(Options, { "$height": props.dropdownHeight, ref: props.dropdownRef, children: [!!props.onCreate && (_jsx(CreateOptionLabel, { children: t("placeholders.selectOrCreateOption") })), (props.options?.length || 0) > 0
                        ? renderOptions?.({ ...props, renderOption })
                        : renderNoOptions?.(props)] }))] }));
};
const CreateOptionLabel = styled.div `
  ${cssBody200Bold};
  padding: 4px 8px;
`;
const Wrapper = styled.div `
  ${boxShadow100};
  width: ${(p) => p.$width};
  min-width: ${(p) => p.$minWidth};
  background: #fff;

  border: 1px solid ${(p) => p.theme.systemColors.grey200};
  border-radius: 6px;
  padding: 8px 0;
`;
const Options = styled.div `
  ${scrollStylesCSS};

  max-height: ${(p) => p.$height || defaultDropdownHeight}px;
  overflow: auto;

  & > div > div {
    ${scrollStylesCSS};
  }
`;
export const USelectDropdown = Object.assign(_USelectDropdown, {
    Wrapper,
    Options,
    CreateOptionLabel,
});
